import { FC } from 'react';
import cls from './card.module.scss';

interface CardProps {
  theme?: 'light' | 'dark' | 'error';
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

export const Card: FC<CardProps> = (props: CardProps) => {
  const { className, children, style, id, theme = 'light' } = props;
  return (
    <div
      className={`${cls.card} ${cls[theme]} ${className}`}
      style={style}
      id={id}
    >
      {children}
    </div>
  );
};
